


















import Vue from 'vue';
import Component from 'vue-class-component';
import characteroverview from './characteroverview.vue';
import { GroupData } from '@/store/types';

@Component({
  components: { characteroverview },
})
export default class Group extends Vue {
  public name: string = '';

  public created() {
    if (typeof this.currentGroupData === 'undefined' && this.currentGroup !== null) {
      this.$store.dispatch('loadGroupData', this.currentGroup);
    }
  }

  get currentGroup(): string | null {
    return this.$store.getters.currentGroup;
  }

  get currentGroupData(): GroupData | undefined {
    return this.$store.getters.currentGroupData;
  }

  get members() {
    if (typeof this.currentGroupData === 'undefined') {
      return [];
    } else {
      return this.currentGroupData.members;
    }
  }

  get isLoading(): boolean {
    return this.currentGroup !== null && this.currentGroupData === null;
  }
}
